module.exports = __webpack_public_path__ + "img/leon1.80faaad6.png";